import { defineComponent, ref, toRefs } from "vue";
import { TASK_STATUS } from "@/common/constant";
export default defineComponent({
  name: "slider-bar",
  props: {
    history: {
      type: Array
    },
    modelValue: {
      type: Number
    },
    load: Function,
    finish: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  setup(props, {
    emit
  }) {
    const scrollBar = ref(null);
    const {
      finish
    } = toRefs(props);
    const loading = ref(false);
    return {
      TASK_STATUS,
      scrollBar,
      select(item, index) {
        emit("update:modelValue", index);
      },
      scrollToOrigin() {
        scrollBar.value.setScrollTop(0);
        scrollBar.value.setScrollLeft(0);
      },
      async onscroll({
        scrollLeft,
        scrollTop
      }) {
        if (loading.value) {
          console.log("loading");
          return false;
        }
        if (finish.value) {
          console.log("finish");
          return false;
        }
        const wrapper = scrollBar.value.wrapRef;
        const {
          scrollHeight,
          scrollWidth
        } = wrapper.children[0];
        const {
          offsetHeight,
          offsetWidth
        } = wrapper;
        // 垂直滚动
        if (scrollLeft === 0 && scrollHeight > offsetHeight) {
          if (scrollTop + 20 >= scrollHeight - offsetHeight) {
            loading.value = true;
            await props.load();
            loading.value = false;
            console.log("到底了");
          }
        }
        // 水平滚动
        if (scrollTop === 0 && scrollLeft > offsetWidth) {
          if (scrollLeft + 20 >= scrollWidth - offsetWidth) {
            loading.value = true;
            await props.load();
            loading.value = false;
            console.log("到右边了");
          }
        }
      }
    };
  }
});